import { type QueryClient, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ItemDescendantsApi } from '@/lib/api/item-store/item-descendants';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const invalidateItemDescendants = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemDescendants.all() });
};

export const useItemDescendants = (
  itemIds: number[],
  staleTime?: number,
  enabled: boolean = true,
) => {
  const itemIdsSet = useMemo(() => new Set(itemIds), [itemIds]);
  const sortedItemIds = useMemo(() => [...itemIdsSet].sort((a, b) => a - b), [itemIdsSet]);

  return useQuery({
    queryKey: commonQueryKeys.itemDescendants.byItemIds(sortedItemIds),
    queryFn: () => ItemDescendantsApi.getItemDescendantsByItemIds(itemIdsSet),
    enabled: enabled && itemIds.length > 0,
    placeholderData: (previousData) => previousData,
    staleTime: staleTime ?? 5 * 60 * 1000, // 5 minutes
  });
};
